import { render, staticRenderFns } from "./cs-portal-config-preferences.vue?vue&type=template&id=8bb00ede"
import script from "./cs-portal-config-preferences.vue?vue&type=script&lang=js"
export * from "./cs-portal-config-preferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports